import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";

import styled from "styled-components";

const HeaderTable = styled.div`
  text-align: center;
  color: #041e42;
  font-size: 24px;
`;

const IconHeader = styled(AnnouncementIcon)`
  vertical-align: text-bottom;
  margin-right: 10px;
  width: 30px !important;
  height: 30px !important;
`;

const HeaderTitulo = styled.span`
  vertical-align: text-bottom;
  margin-bottom: 10px;
`;

const ModalContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
  padding: 8px 0;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #041e42;
  margin-bottom: 2px;
  text-transform: uppercase;
`;

const Value = styled.span`
  font-size: 14px;
  color: #333;
`;

const TabelaOcorrencias = (props) => {
  const [ocorrencias, setOcorrencias] = useState([]);
  const [ocorrenciaSelecionada, setOcorrenciaSelecionada] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    setOcorrencias(props.fatura?.ocorrencias || []);
  }, [ocorrencias, props]);

  const header = (
    <HeaderTable>
      <p>
        <IconHeader />
        <HeaderTitulo>OCORRÊNCIAS</HeaderTitulo>
      </p>
    </HeaderTable>
  );

  const valorBodyTemplate = (rowData) => {
    const options = {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    const formatNumber = new Intl.NumberFormat("pt-BR", options);
    let value = rowData.valor;
    var formattedMoney = formatNumber.format(value);
    return formattedMoney;
  };
  const detalhesBodyTemplate = (rowData) => (
    <IconButton
      onClick={() => {
        setOcorrenciaSelecionada(rowData);
        setModalVisible(true);
      }}
      sx={{ color: "#041E42" }}
    >
      <SearchIcon />
    </IconButton>
  );
  const formatMoney = (value) =>
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);

  return (
    <>
      <DataTable
        header={header}
        value={ocorrencias}
        size="small"
        stripedRows
        scrollable
        scrollHeight="500px"
        tableStyle={{ minWidth: "100%" }}
      >
        <Column
          field="numero"
          header="Nº Ocorrência"
          style={{ minWidth: "110px" }}
          bodyStyle={{ padding: "8px" }}
          headerStyle={{
            backgroundColor: "#041E42",
            color: "white",
          }}
        />

        <Column
          body={detalhesBodyTemplate}
          header="Detalhe Ticket"
          style={{ minWidth: "100px" }}
          bodyStyle={{ textAlign: "center", padding: "4px" }}
          headerStyle={{
            backgroundColor: "#041E42",
            color: "white",
            textAlign: "center",
          }}
        />

        <Column
          field="obs"
          header="Observação"
          style={{ minWidth: "600px" }} // 👈 AQUI faz diferença
          bodyStyle={{ padding: "8px" }}
          headerStyle={{
            backgroundColor: "#041E42",
            color: "white",
          }}
        />

        <Column
          header="Valor"
          body={(rowData) => (
            <span style={{ fontWeight: 600 }}>
              {valorBodyTemplate(rowData)}
            </span>
          )}
          style={{ minWidth: "140px" }}
          bodyStyle={{
            textAlign: "right",
            paddingRight: "12px",
          }}
          headerStyle={{
            backgroundColor: "#041E42",
            color: "white",
            textAlign: "right",
            paddingRight: "12px",
          }}
        />
      </DataTable>
      <Dialog
        open={modalVisible}
        onClose={() => setModalVisible(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            color: "#041E42",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Detalhes do Ticket
          <IconButton onClick={() => setModalVisible(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {ocorrenciaSelecionada && (
            <ModalContainer>
              <Field>
                <Label>Passageiro</Label>
                <Value>{ocorrenciaSelecionada.pax}</Value>
              </Field>

              <Field>
                <Label>Ticket</Label>
                <Value>{ocorrenciaSelecionada.numtkt}</Value>
              </Field>

              <Field>
                <Label>Loc</Label>
                <Value>{ocorrenciaSelecionada.loc}</Value>
              </Field>

              <Field>
                <Label>Cia</Label>
                <Value>{ocorrenciaSelecionada.codcia}</Value>
              </Field>

              <Field>
                <Label>Tarifa</Label>
                <Value>{formatMoney(ocorrenciaSelecionada.tarifa)}</Value>
              </Field>

              <Field>
                <Label>Taxa</Label>
                <Value>{formatMoney(ocorrenciaSelecionada.taxa)}</Value>
              </Field>
            </ModalContainer>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            onClick={() => setModalVisible(false)}
            sx={{
              backgroundColor: "#041E42",
              "&:hover": {
                backgroundColor: "#03306b",
              },
            }}
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TabelaOcorrencias;
